import { login,loginZb, getInfo, loginEn, loginLC } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { decrypt } from '@/utils/rsaEncrypt'

const user = {
  state: {
    token: getToken(),
    user: {},
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    // 设置token
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    // 设置名字
    SET_NAME: (state, name) => {
      state.name = name
    },
    // 设置化身
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    // 设置角色
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const checkcode  = userInfo.checkcode
      // const code = userInfo.code
      // const uuid = userInfo.uuid
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        login(username, password, code,checkcode).then(res => {

          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登录
    LoginZb({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = decrypt(userInfo.password)
      const code = userInfo.code
      const checkcode  = userInfo.checkCode
      // const code = userInfo.code
      // const uuid = userInfo.uuid
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginZb(username, password, code, checkcode).then(res => {
          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // have token login
    NoToken({commit}, userToken) {
      console.log(userToken);
      return new Promise((resolve, reject) => {
          setToken(userToken)
          commit('SET_TOKEN', userToken)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)
          resolve()
      })
    },

    // 英文登录
    LoginEn({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = decrypt(userInfo.password)
      const code = userInfo.code
     
      // const code = userInfo.code
      // const uuid = userInfo.uuid
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginEn(username, password, code).then(res => {
          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)s
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    // 联创登录
    LoginLC({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = decrypt(userInfo.password)
      // const code = userInfo.code
      // const uuid = userInfo.uuid
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginLC(username, password).then(res => {
          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          commit('SET_ROLES', res.jwtUser.roles)
          commit('SET_NAME', res.jwtUser.username)
          commit('SET_AVATAR', res.jwtUser.avatar)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resolve()
      })
    },
    // 登出
    LogOutT({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js